import { Route, Routes } from "react-router-dom";
import { CatalogTundishProvider } from "./context/CatalogTundishContext";
import { CatalogTundishPage } from "./pages/CatalogTundishPage";

type Props = {};
const CatalogTundish = (props: Props) => {
  return (
    <CatalogTundishProvider>
      <Routes>
        <Route index element={<CatalogTundishPage />} />
        <Route path=":tundishId" element={<CatalogTundishPage />} />
      </Routes>
    </CatalogTundishProvider>
  );
};
export default CatalogTundish;
